const responseType = 'code';
const scope = 'email+openid+profile';

export const buildAuthUrl = (params: {
  cognitoDomain: string;
  clientId: string;
  redirectUri: string;
  type: 'login' | 'forgotPassword';
  state?: string;
}) => {
  const { cognitoDomain, clientId, redirectUri, type, state } = params;
  const baseUrl = type === 'login' ? `${cognitoDomain}/login` : `${cognitoDomain}/forgotPassword`;
  const stateParam = state ? `&state=${state}` : '';
  return `${baseUrl}?client_id=${clientId}&response_type=${responseType}&scope=${scope}&redirect_uri=${redirectUri}${stateParam}`;
};
